import React from "react";
import { Box, Skeleton, IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const CrossingTradesSkeleton = () => {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        overflow: "hidden",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          flexShrink: 0,
        }}
      >
        <Box sx={{ width: "44%" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Skeleton variant="text" width={150} height={32} />
            <Skeleton variant="rectangular" width={120} height={32} sx={{ borderRadius: 1 }} />
          </Box>
          <Box sx={{ display: "flex", gap: 2, mt: 1, alignItems: "center" }}>
            <Skeleton variant="rectangular" width={200} height={32} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width={220} height={32} sx={{ borderRadius: 1 }} />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
            <Skeleton variant="rectangular" width={40} height={20} sx={{ borderRadius: 10 }} />
            <Skeleton variant="text" width={180} height={20} />
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <IconButton sx={{ backgroundColor: "#f5f5f5", border: "1px solid #e0e0e0" }}>
            <MoreVertIcon />
          </IconButton>
          <Skeleton variant="rectangular" width={150} height={40} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "45%",
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: "100%",
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <Box sx={{ display: "flex", p: 1.5, borderBottom: "1px solid #ccc", flexShrink: 0 }}>
              {Array.from({ length: 7 }).map((_, index) => (
                <Skeleton key={index} variant="text" width={80} height={24} sx={{ mr: 2 }} />
              ))}
            </Box>
            <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", p: 1.5 }}>
              {Array.from({ length: 20 }).map((_, index) => (
                <Box key={index} sx={{ display: "flex", mb: 1, py: 0.5 }}>
                  {Array.from({ length: 7 }).map((__, colIndex) => (
                    <Skeleton key={colIndex} variant="text" width={80} height={16} sx={{ mr: 2 }} />
                  ))}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CrossingTradesSkeleton;
